var collapsible_list_component_default = {
  "ltr": "JbBy9",
  "rtl": "udgLJ",
  "iconContainer": "LTSAL",
  "icon": "k5-s8",
  "isExpanded": "LlbQA",
  "listDimensions": "eJ6cG"
};
export {
  collapsible_list_component_default as default
};
//# sourceMappingURL=collapsible-list-component-scss.js.map
